import { createScopedInstanceAndLoader } from '@citrite/translate';

const instance = createScopedInstanceAndLoader({
	namespace: 'view-engine-pilet',
	localesLoaderMap: {
		en: () => import('./locales/en.json'),
		es: () => import('./locales/es.json'),
		ja: () => import('./locales/ja.json'),
		de: () => import('./locales/de.json'),
		fr: () => import('./locales/fr.json'),
		'pt-BR': () => import('./locales/pt-BR.json'),
		it: () => import('./locales/it.json'),
		nl: () => import('./locales/nl.json'),
	},
});

export const t: (str: string, opts?: any) => string = instance.t;

export const { LocalizationLoader } = instance;
